import OpeningHours from './opening-hours';

export default class DealerMapper {
    static map(result, service) {
        if (result) {
            const { dealer } = result;
            const address = dealer?.address;
            const countryName = address.country.toLowerCase();
            const leadCodes = [...new Set((dealer.productServices || []).map((ps) => ps.leadCode).filter((code) => code))];
            return {
                name: dealer.name,
                uri: dealer.uri,
                alias: dealer.alias,
                origin: result.origin,
                address: {
                    lat: address.lat,
                    lng: address.lng,
                    formatted: countryName === 'germany' ? [address.addressLine1, address.addressLine2, address.postalcode, address.city, address.state].filter((a) => a).join(', ') :
                    [address.addressLine1, address.addressLine2, address.city, address.state, address.postalcode].filter((a) => a).join(', '),
                    km: result.distanceInKm,
                    miles: result.distanceInMiles,
                },
                telephone: dealer.productServices.find((s) => (service ? service === s.code : s.telephoneNumber))?.telephoneNumber,
                email: dealer.productServices.find((s) => (service ? service === s.code : s.emailAddress))?.emailAddress,
                contactForm: dealer.productServices.find((s) => service ? service === s.code : s?.content?.contactForm)?.content?.contactForm,
                openingHours: OpeningHours.format(dealer.productServices.find((s) => (service ? service === s.code : s.openingHours.length))?.openingHours),
                website: dealer.website,
                additionalInfo: 'additionalInfo' in dealer ? dealer.additionalInfo : {},
                productServices: dealer.productServices,
                leadCodes,
                type: dealer.type,
            };
        }
    }
}
